import { useState, useEffect, useCallback } from "react";
import { fetchSchemaGraph } from "./../api/apiService";

const useGraphData = () => {
  const [graphSchemaData, setGraphSchemaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadGraphData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchSchemaGraph();
      const filteredEdges = data?.edges?.filter(
        (edge) => edge.source !== edge.target
      );

      // Update the data with filtered edges
      data.edges = filteredEdges;
      setGraphSchemaData(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadGraphData();
  }, [loadGraphData]);

  const refetch = useCallback(() => {
    loadGraphData();
  }, [loadGraphData]);

  return { graphSchemaData, loading, error, refetch };
};

export default useGraphData;
